(function () {
  const BLOCK_SELECTOR = '[data-cart-delivery-preference]';
  const LINE_SELECTOR = '[data-cart-item-status][data-cart-item-top-level="true"]';

  function isDrawerScope(scope) {
    return !!(scope.closest('cart-drawer') || scope.querySelector('#CartDrawer'));
  }

  function getCheckoutButton(scope) {
    return isDrawerScope(scope)
      ? document.getElementById('CartDrawer-Checkout')
      : document.getElementById('checkout');
  }

  function getDynamicCheckoutWrap(scope) {
    if (isDrawerScope(scope)) return null;
    return document.querySelector('.additional-checkout-buttons');
  }

  function getRelevantLines(scope) {
    if (isDrawerScope(scope)) {
      return scope.querySelectorAll(LINE_SELECTOR);
    }

    const cartItemsRoot = document.querySelector('#main-cart-items');
    if (!cartItemsRoot) return [];
    return cartItemsRoot.querySelectorAll(LINE_SELECTOR);
  }

  function getMixedStatus(scope) {
    const lines = getRelevantLines(scope);
    let hasInStock = false;
    let hasPreorder = false;

    lines.forEach((line) => {
      const status = line.dataset.cartItemStatus;
      if (status === 'in_stock') hasInStock = true;
      if (status === 'preorder') hasPreorder = true;
    });

    return hasInStock && hasPreorder;
  }

  function hasSelection(container) {
    if (!container) return true;
    const inputs = container.querySelectorAll('input[name="attributes[Delivery preference]"]');
    return Array.from(inputs).some((input) => input.checked);
  }

  function toggleCheckout(scope, enabled) {
    const checkoutButton = getCheckoutButton(scope);
    const dynamicCheckoutWrap = getDynamicCheckoutWrap(scope);

    if (checkoutButton) {
      checkoutButton.disabled = !enabled;
      checkoutButton.classList.toggle('is-disabled', !enabled);
      checkoutButton.setAttribute('aria-disabled', String(!enabled));
    }

    if (dynamicCheckoutWrap) {
      dynamicCheckoutWrap.hidden = !enabled;
      dynamicCheckoutWrap.setAttribute('aria-hidden', String(!enabled));
    }
  }

  function bindBlock(scope, block) {
    if (!block || block.dataset.bound === 'true') return;

    block.dataset.bound = 'true';

    const inputs = block.querySelectorAll('input[name="attributes[Delivery preference]"]');
    const error = block.querySelector('[data-cart-delivery-preference-error]');

    inputs.forEach((input) => {
      input.addEventListener('change', () => {
        if (error) error.hidden = true;
        toggleCheckout(scope, true);
      });
    });

    const checkoutButton = getCheckoutButton(scope);
    if (checkoutButton) {
      checkoutButton.addEventListener('click', function (event) {
        if (!hasSelection(block)) {
          event.preventDefault();
          event.stopPropagation();
          if (error) error.hidden = false;
          block.scrollIntoView({ behavior: 'smooth', block: 'center' });
          if (inputs[0]) inputs[0].focus();
        }
      });
    }
  }

  function updateScope(scope) {
    const block = scope.querySelector(BLOCK_SELECTOR);
    const isMixed = getMixedStatus(scope);

    if (!isMixed) {
      if (block) block.style.display = 'none';
      toggleCheckout(scope, true);
      return;
    }

    if (!block) {
      toggleCheckout(scope, true);
      return;
    }

    block.style.display = '';
    bindBlock(scope, block);
    toggleCheckout(scope, hasSelection(block));
  }

  function initAll() {
    document.querySelectorAll('cart-drawer, #main-cart-footer').forEach((scope) => {
      updateScope(scope);
    });
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);

  const observer = new MutationObserver(() => {
    initAll();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();